module.exports = __webpack_public_path__ + "img/housing_1.0bdf4160.jpg";